import React, { RefObject } from 'react';
import { EFileExportTypes, EFileImportTypes } from 'enums/EFileExportTypes';
import {
  ImportIngredientsDTO,
  NavigatorMapDTO,
  PlateWellDTO,
} from 'business/models/Models';
import { ExperimentCanvasRoute } from 'components/Experiment/constants';

export type ExpDashboardContextType = {
  fileExportActionType: EFileExportTypes;
  setFileExportActionType: (e: EFileExportTypes) => void;
  fileImportActionType: EFileImportTypes;
  setFileImportActionType: (e: EFileImportTypes) => void;
  importedIngredientCoflicts: ImportIngredientsDTO;
  setImportedIngredientCoflicts: (value: ImportIngredientsDTO) => void;
  setSelectedSidePanelTab: (...args) => void;
  selectedSidePanelTab: number;
  imagedWells: PlateWellDTO[];
  triggerZoom: (wellKey: string, zoom: number) => void;
  cursorClass: string;
  setCursorClass: React.Dispatch<React.SetStateAction<string>>;
  canvasContainerRef: RefObject<HTMLDivElement>;
  isCanvasInFocus: boolean;
  setIsCanvasInFocus: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCanvasRoute: ExperimentCanvasRoute | null;
  setSelectedCanvasRoute: React.Dispatch<
    React.SetStateAction<ExperimentCanvasRoute | null>
  >;
  navigatorMap: NavigatorMapDTO;
  dropImageVerticalPrefetchingCount: number;
  dropImageHorizontalPrefetchingCount: number;
  navigatorVerticalPrefetchingCount: number;
  navigatorHorizontalPrefetchingCount: number;
  navigateToDesignView: () => void;
  registerDesignTabSwitcher: (switcher: (() => void) | null) => void;
};

const defaultExpDashboardContext: ExpDashboardContextType = {
  fileExportActionType: EFileExportTypes.NONE,
  setFileExportActionType: () => {},
  fileImportActionType: EFileImportTypes.NONE,
  setFileImportActionType: () => {},
  importedIngredientCoflicts: {} as ImportIngredientsDTO,
  setImportedIngredientCoflicts: () => {},
  setSelectedSidePanelTab: () => {},
  selectedSidePanelTab: 0,
  imagedWells: [],
  triggerZoom: () => {},
  cursorClass: '',
  setCursorClass: () => {},
  canvasContainerRef: { current: null },
  isCanvasInFocus: false,
  setIsCanvasInFocus: () => {},
  selectedCanvasRoute: null,
  setSelectedCanvasRoute: () => {},
  navigatorMap: {} as NavigatorMapDTO,
  dropImageVerticalPrefetchingCount: 0,
  dropImageHorizontalPrefetchingCount: 0,
  navigatorVerticalPrefetchingCount: 0,
  navigatorHorizontalPrefetchingCount: 0,
  navigateToDesignView: () => {},
  registerDesignTabSwitcher: () => {},
};

export const ExpDashboardContext = React.createContext<ExpDashboardContextType>(
  defaultExpDashboardContext,
);
